/**
 * @template T
 * @param {{ default: T }} f
 * @see {@link https://github.com/rollup/plugins/issues/1541}
 */
export const fixCjsModule = (f) => /** @type {T} */ (f);
